import React from 'react';

export default function ServerError() {
    return (
        <div>
            <div className="centerify r-pvl">
                <h1>Beklager, nå er det rusk i maskineriet.</h1>
                <p className="largetext">
                    Prøv igjen om litt, eller få mer informasjon hos{' '}
                    <a href="//hjelpesenter.finn.no">Hjelpesenteret</a>.
                </p>
            </div>
            <p>
                <img
                    alt="Rufsete katt"
                    className="blockify"
                    src="//m.finn.no/images/500.jpg"
                />
            </p>
        </div>
    );
}
